export default ({ alertTip }) => <>
  <div className="projecttarget" id="projecttarget1">
    <h2 className="cs-title_title title_titlef" >
      <div className="min-titlef-blue"></div>
      01. 탄소 크레딧 프로젝트 등록 개요
    </h2>
    <div className="cs-bid_info">
      탄소 크레딧 프로젝트는 온실가스 배출을 줄이거나 제거하는 활동을 통해 탄소 크레딧을 발행받는 것을 목표로 합니다.
      이러한 프로젝트는 기업의 지속 가능성 목표 달성, 환경 보호, 그리고 탄소 시장에서의 거래를 통해 경제적 이익을 얻을 수 있습니다.
    </div>
  </div>
  <div className="projecttarget" id="projecttarget2">
    <h2 className="cs-title_title title_titlef">
      <div className="min-titlef-blue"></div>
      02. 프로젝트 등록 절차
    </h2>
    <div className="cs-bid_info">
      <div>프로젝트 등록은 다음과 같은 단계로 이루어집니다.</div>
      <div className="min-titlef">1) 프로젝트 등록 요청</div>
      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li><label>등록 방법</label>: 본 플랫폼의 [프로젝트 등록 신청] 버튼을 클릭하여 신청합니다.</li>
          <li><label>이메일 발송</label>: 신청 후, 등록된 이메일 주소로 프로젝트 신청서 양식(PDF 또는 Word 파일)이 자동 발송됩니다.</li>
          <li><label>신청서 작성 </label>: 신청자는 이메일을 확인하고, 프로젝트 등록에 필요한 세부 정보를 양식에 작성한 후, 지정된 이메일 주소로 제출해야 합니다.</li>
          <li><label>접수 확인 </label>: 프로젝트 등록 신청서를 제출하면, 접수 확인 이메일이 발송되며, 신청자의 프로젝트가 심사 대기 상태로 전환됩니다.</li>
        </ul>
      </div>
      <div className="min-titlef">2) 프로젝트 문서 제출</div>
      <div style={{ fontSize: "18px", marginBottom: "20px" }}>프로젝트 등록 요청 후, 신청자는 심사에 필요한 문서를 제출해야 합니다. 문서는 다음과 같은 주요 항목을 포함해야 합니다.</div>
      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li><label>프로젝트 개요</label>: 프로젝트명, 위치, 주관 기관 및 담당자 정보, 프로젝트 유형(예: DAC, EW 등), 방법론 적용 여부(적용/신규 개발/기존 방법론 개정)</li>
          <li><label>탄소 감축 계획 및 예측 데이터 </label>:  베이스라인 설정, 연간 예상 탄소 감축량, 탄소 배출 저감 메커니즘 및 기술 설명</li>
          <li><label>프로젝트 타임라인  </label>: 시작 및 종료 예상일, 주요 단계 및 일정 계획</li>
          <li><label>재무 정보 및 투자 계획</label>: 프로젝트 예산 및 운영 계획, 보조금</li>
          <li><label>법적 및 환경 영향 평가 </label>: 환경 영향 평가, 지역 사회 및 이해관계자 참여 여부</li>
          <li><label>기타 필수 서류  </label>: 인증 기관 요구 사항에 따른 추가 문서, 외부기관 타당성 평가 보고서. 모든 문서는 PDF 또는 Word 형식으로 제출해야 하며, 파일 크기 제한이 있을 수 있습니다.</li>
        </ul>
      </div>
      <div className="min-titlef">3) 심사 및 승인 절차</div>
      <div style={{ fontSize: "18px", marginBottom: "20px" }}>프로젝트가 접수되면, 심사팀에서 프로젝트 서류를 검토하고 다음과 같은 과정을 거칩니다.</div>
      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li><label>방법론 평가 (최대 15영업일 소요) </label>: 기존 승인된 방법론이 적용 가능한지 평가를 진행합니다. 적용이 승인 되지 않을 경우, 프로젝트 신청자는 기존 승인된 방법론을 활용하여 방법론 개정을 요청할 수 있으며, 신규 방법론 등록 절차가 필요할 수 있습니다.</li>
          <li><label>1차 서류 검토 (최대 10영업일 소요)  </label>:  제출된 문서가 모든 요구 사항을 충족하는지 확인합니다. 누락된 서류가 있을 경우, 보완 요청이 이메일로 발송됩니다.</li>
          <li><label>기술 심사 (최대 30영업일 소요)  </label>: 프로젝트 타당성 평가 및 예상 탄소 감축량 산출결과에 대한 평가를 진행합니다. 환경 영향 평가와 법적 요건 충족 여부도 확인합니다. 필요한 경우 추가 서류 요청 또는 인터뷰가 진행될 수 있습니다.</li>
          <li><label>최종 승인 또는 거절 결정 (최대 15영업일 소요)</label>: 심사가 완료되면 승인 여부가 결정됩니다. 승인된 프로젝트는 선발행 탄소 크레딧 절차로 넘어갑니다. 미승인된 프로젝트의 경우, 사유와 함께 최종 의견 제출을 요청하며 승인 여부를 재심사합니다.</li>
        </ul>
      </div>
    </div>
  </div>
  <div className="projecttarget" id="projecttarget3">
    <h2 className="cs-title_title title_titlef" >
      <div className="min-titlef-blue"></div>
      03. 프로젝트 심사 결과 및 후속 조치
    </h2>
    <div className="cs-bid_info">
      <div>프로젝트 심사 결과는 신청자의 이메일로 통보됩니다.</div>
      <div className="min-titlef">1) 승인된 경우</div>
      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li><label>프로젝트 등록</label>: 프로젝트가 공식적으로 등록되며, 등록 6개월 이후 프로젝트 개요가 공개됩니다.</li>
          <li><label>선발행 탄소 크레딧 지급 </label>: 이후, 프로젝트 등록자는 선발행 탄소 크레딧 및 거래에 필요한 추가 절차를 진행하게 됩니다. 등록된 프로젝트는 선발행 탄소 크레딧을 지급받을 수 있습니다.</li>
          <li><label>프로젝트 진행 평가  </label>: 기존에 제출된 프로젝트 문서에 따라 프로젝트가 정상적으로 진행되고 있는지를 주기적으로 평가합니다. 프로젝트 진행이 불가하다고 판단되는 경우 프로젝트 등록을 취소하고 기존에 지급된 선발행 탄소 크레딧을 폐기할 수 있습니다.</li>
          <li><label>탄소 크레딧 발행  </label>: 사업 시행 이후 모니터링 보고서를 통해 실제 온실가스 배출량 감축이 확인되면, 탄소 크레딧이 발행됩니다.</li>
        </ul>
      </div>
      <div className="min-titlef">2) 거절된 경우</div>
      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li><label>거절 사유 통보</label>: 거절 사유가 이메일을 통해 상세히 전달됩니다.</li>
          <li><label>보완 및 재심사 요청  </label>: 거절된 프로젝트는 필요한 사항을 보완한 후 재심사를 요청할 수 있습니다.</li>
          <li><label>*재심사 요청 방법:  </label>
            <div>
               <ol style={{ marginBottom: 0, "listStyleType":"none", "paddingLeft":"7px" }}>
                <li>① 거절 사유를 검토한 후, 요구된 추가 서류를 준비합니다.</li>
                <li>② 보완된 문서를 다시 제출합니다.</li>
                <li>③ 재단에서 보완된 문서를 재검토하고, 최종 승인 여부를 결정합니다.</li>
              </ol>
            </div>
          </li>
        </ul>
      </div>
      <div className="min-titlef">3) 신규 방법론 등록 절차</div>
      <div style={{ fontSize: "18px", marginBottom: "20px" }}>기존 방법론을 적용할 수 없는 경우, 신규 방법론 등록 절차를 거쳐야 합니다.</div>
      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li><label>기존 방법론 활용 검토</label>: 기존 방법론을 활용하여 프로젝트에 적용 가능한 새로운 방법론을 개발할 수 있는지 검토합니다.</li>
          <li><label>신규 방법론 등록  </label>: 방법론 신규 등록을 위한 별도 절차를 진행해야 합니다.</li>
        </ul>
      </div>
    </div>
  </div>
  <div className="projecttarget" id="projecttarget4">
    <h2 className="cs-title_title title_titlef">
      <div className="min-titlef-blue"></div>
      04. 프로젝트 진행 중 추가 요청 사항
    </h2>
    <div className="cs-bid_info">
      <div>프로젝트가 승인된 이후에도, 특정한 사유로 인해 추가 요청을 할 수 있습니다.</div>
      <div className="min-titlef">1) 프로젝트 정보 수정 요청</div>
      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li><label>수정 요청</label>: 프로젝트 등록 후, 특정 정보(예: 담당자 변경, 프로젝트 일정 변경 등)를 수정해야 하는 경우, 프로젝트 관리 페이지에서 수정 요청을 할 수 있습니다.</li>
          <li><label>검토 및 승인</label>: 수정 요청이 접수되면, 검토 후 승인 여부를 결정합니다.</li>
        </ul>
      </div>
      <div className="min-titlef">2) 추가 문서 제출</div>
      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li><label>추가 서류 업로드</label>: 탄소 크레딧 인증 절차에서 추가 문서 제출이 필요한 경우, 플랫폼을 통해 추가 서류 업로드 요청을 할 수 있습니다.</li>
        </ul>
      </div>
    </div>
  </div>
  <div className="projecttarget" id="projecttarget5">
    <h2 className="cs-title_title title_titlef" >
      <div className="min-titlef-blue"></div>
      05. 프로젝트 진행 시 유의사항
    </h2>
    <div className="cs-bid_info">
      <div>프로젝트 등록자는 아래 사항을 반드시 숙지해야 합니다.</div>
      <div className="min-titlef">1) 데이터 제출</div>
      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li><label>모니터링 준수</label>: 모든 데이터는 해당 방법론의 모니터링 절차를 준수해야 합니다.</li>
          <li><label>방법론 업데이트</label>: 기존에 승인된 프로젝트라도, 해당 방법론에 변경 사항이 발생한 경우 이를 프로젝트에 수정 반영해야 합니다.</li>
          <li><label>신뢰성 확보 </label>: 모든 방법론과 프로젝트는 제3자에 의한 데이터 검증이 필수입니다. 절차를 준수하지 않거나 허위 데이터를 제출할 경우, 재단은 프로젝트 승인을 취소할 수 있습니다.</li>
        </ul>
      </div>
      <div className="min-titlef">2) 문서 양식 준수</div>
      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li><label>형식 및 표준 준수 </label>: 요구되는 형식(PDF, Word) 및 표준 양식을 준수해야 합니다.</li>
        </ul>
      </div>
      <div className="min-titlef">3) 거절 시 보완 요청 대응</div>
      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li><label>보완 요청 대응</label>: 심사 과정에서 보완 요청이 있을 수 있으며, 이에 대한 응답이 없을 경우 프로젝트 등록이 취소될 수 있습니다.</li>
        </ul>
      </div>
    </div>
  </div>
  <div className="projecttarget" id="projecttarget6">
    <h2 className="cs-title_title title_titlef">
      <div className="min-titlef-blue"></div>
      06. 고객 지원
    </h2>
    <div className="cs-bid_info" style={{ paddingBottom: "200px" }}>
      <div style={{ marginBottom: "20px" }}>프로젝트 등록 및 심사 과정에서 궁금한 점이 있거나 기술적 지원이 필요한 경우, 다음의 방법으로 문의하실 수 있습니다.</div>
      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li><label>이메일 문의</label>: help@capcotwo.com</li>
        </ul>
      </div>
      <div style={{ fontSize: "15px" }}>
        <label style={{ fontWeight: "bold" }}>* 첨부파일 설명</label> <br />탄소 크레딧 프로젝트 등록 필수 문서 안내<br /><br />
        
        문서 제출 시 유의사항 :
        <ul style={{ marginBottom: 0, marginLeft: "1px", "listStyleType":"none" }}>
          <li>① 모든 문서는 PDF 또는 Word 형식으로 제출해야 합니다.</li>
          <li>② 문서의 내용은 정확하고 객관적인 데이터를 기반으로 작성해야 합니다.</li>
          <li>③ 기후재단에서 요구하는 템플릿이 있을 경우, 해당 템플릿을 사용해야 합니다.</li>
          <li>④ 파일 크기는 개별 10MB 이하로 제한되며, 추가 자료 제출이 필요한 경우에는 ZIP 파일로 압축하여 제출할 수 있습니다.</li>
        </ul>
      </div>
      <button className="cs-btn cs-style1" style={{ borderRadius: "10px", float: "right", marginTop: "20px" }} onClick={alertTip}><span style={{ position: "relative" }}>프로젝트 등록 신청</span></button>
    </div>
  </div>
</>